import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { PlansRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })

export class ImportPlanCSVUsecase implements UseCase<FormData,boolean> {

  constructor(private readonly planRepository: PlansRepository) {
  }

  execute(param: FormData): Observable<boolean> {
    return this.planRepository.importPlanCSV(param);
  }

}
